import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    
    
}
const mutations={
   
    setUserPassword(state,value){
        


        post(urls.admin.password.index,value).then((result)=>{
          
          
          state.result=result
         
       
        
       
           
        });
        
    },
   
 

     
  
  
    
 

}
const  actions={

    
   setUserPasswordAction(context,value){
       
        context.commit("setUserPassword",value)
       
    },
  
  
    

}

export default {state,mutations,actions}